import { schema } from 'normalizr';

export const TILE = 'tiles';
export const TILES_GROUP = 'tilesGroups';
export const TILES_TYPE = 'tilesTypes';

export const tileSchema = new schema.Entity(TILE);
tileSchema.define({ children: [tileSchema] });

export const tilesTypeSchema = new schema.Entity(TILES_TYPE);
export const tilesGroupSchema = new schema.Entity(TILES_GROUP, {
  tiles: [tileSchema],
  type: tilesTypeSchema
});
